import React, { useState, useEffect } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import type { UploadProps as AntdUploadProps, UploadFile } from 'antd';
import { registerComponentProperty } from '../util/util'
import { Upload as AntdUpload, message } from 'antd';

const { Dragger } = AntdUpload;

export type UploadProps = AntdUploadProps & {
  maxSize?: number
  value?: UploadFile[]
  onChange?: (fileList: UploadFile[]) => void
}

const DraggerUploader = (props: UploadProps) => {
  const metaElement = document.querySelector(
    'meta[name="csrf-token"]'
  ) as HTMLMetaElement
  const maxSize = props.maxSize || 1024*10
  const [fileList, setFileList] = useState<UploadFile[]>(props.value || []);

  useEffect(() => {
    if (props.value !== undefined) {
      setFileList(props.value);
    }
  }, [props.value]);

  const handleChange: UploadProps['onChange'] = (info) => {
    let newFileList = [...info.fileList];

    newFileList = newFileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(newFileList);
    
    if (props.onChange) {
      props.onChange(newFileList);
    }
  }

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/')
    
    let sizeLimit = maxSize
    if (!maxSize) {
      sizeLimit = isImage ? 1024 * 2 : 1024 * 10 // 图片2M，其他10M
    }

    const fileSizeInKB = file.size / 1024
    const inLimit = fileSizeInKB < sizeLimit

    if (!inLimit) {
      file.status = "removed"
      const sizeLimitInMB = (sizeLimit / 1024).toFixed(1)
      const fileType = isImage ? '图片' : '文件'
      message.error(`${fileType}大小不能超过 ${sizeLimitInMB}MB!`)
    }

    return inLimit
  }

  const { value, onChange, ...restProps } = props;

  return (
    <Dragger
      {...restProps}
      fileList={fileList}
      onChange={handleChange}
      action={props.action || "/api/v1/attachments/upload"}
      beforeUpload={beforeUpload}
      headers={{
        "X-CSRF-Token": metaElement.content,
      }}
      name="file"
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">点击或者拖拽文件到此区域上传</p>
      <p className="ant-upload-hint">
        支持单个或批量上传。禁止上传公司数据或其他禁止的文件。
      </p>
    </Dragger>
  )
}

export default registerComponentProperty<typeof DraggerUploader, typeof AntdUpload>(DraggerUploader, AntdUpload)